// 麦克风/摄像头权限被拒时的行内引导条——通话发起、未来的语音消息录制按钮
// 复用同一个组件（coordinator 原话："通话与语音复用同一套"）。非模态，视觉
// 对齐 chat.js 既有的 email-gate-bar（中性、内联、--lc-* token 化，不是
// realtime-call-new.js 那条更早期的红色报错条——那条是"已经出错"的语气，
// 这条是"需要你做一步操作"的语气，语义不同，没有理由跟着用报错色）。
//
// 展示与否、"去设置"按钮显不显示，都是 permission-bridge.js 里的纯函数
// （shouldShowGuidanceBar/shouldShowSettingsButton）决定，这个组件本身不做
// 判断，只管渲染——调用方（chat.js/realtime-call-new.js）传 kind + 状态即可。

import React from 'react';
import { t } from '../i18n';
import bridge from './native-bridge.js';

/**
 * @param {'microphone'|'camera'} props.kind
 * @param {boolean} [props.showSettingsButton] 不传则用 bridge.supports('openAppSettings') 现查
 */
export default function PermissionGuidanceBar({ kind, showSettingsButton, style }) {
    const titleKey = kind === 'camera' ? 'permission.camera_required' : 'permission.mic_required';
    const canOpenSettings = showSettingsButton !== undefined
        ? showSettingsButton
        : (bridge.isActive() && bridge.supports('openAppSettings'));

    return (
        <div className="lc-permission-guidance-bar" style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 'var(--lc-space-2)',
            padding: 'var(--lc-space-2) var(--lc-space-4)',
            fontSize: '13px',
            color: 'var(--lc-text-2, #475569)',
            background: 'var(--lc-bg, #f8fafc)',
            borderTop: 'var(--lc-hairline)',
            textAlign: 'center',
            flexWrap: 'wrap',
            ...style,
        }}>
            <span>{t(titleKey)}</span>
            {canOpenSettings && (
                <button
                    type="button"
                    onClick={() => bridge.call('openAppSettings', {})}
                    style={{
                        flexShrink: 0,
                        border: 'var(--lc-hairline)',
                        borderRadius: 'var(--lc-radius-sm)',
                        background: 'var(--lc-surface, #fff)',
                        color: 'var(--lc-text, #1e293b)',
                        fontSize: '12px',
                        fontWeight: 600,
                        padding: '3px 10px',
                        cursor: 'pointer',
                    }}
                >
                    {t('permission.open_settings')}
                </button>
            )}
        </div>
    );
}
